import React from 'react';
import {Redirect,Route} from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import { connect } from 'react-redux';
import {routeName} from '../../../src/Service/env';
import Loader from '../../Helper/loader/loader';

const PaymentRoute = ({...props})=>{
    const token = localStorage.getItem('token');
    const businessId = localStorage.getItem('BusinessId');
    let access
    let decoded;
    try {
        if (token === undefined) {
            access = false
        }
        else {
            decoded = jwt_decode(token)
        }
    } catch (err) {
        console.log(err);
    }
    let currentTime = Math.floor(Date.now()/1000);
    if(!decoded || !decoded.exp){
        localStorage.removeItem('token');
        access = false;
    }
    else
    {
        if (decoded.exp < currentTime) {
            access = false;
            localStorage.removeItem('user');
        }
        else {
            access = true;
        }
    }
    return (
        access ?
            (Object.keys(props.user).includes('Message')) ?
                (props.user && props.user.IsSubscribe === false && businessId) ?
                    <Route {...props} />
                    :
                  (props.user.IsPlanCanceled)?
                    <Route {...props} />
                    : <Redirect to={`/${routeName}/Dashboard/Overview`} />
                :
                <div>
                    <div className='no-data'><Loader/></div>
                </div>
            : <div>
            <Redirect to={`/${routeName}`}/>
        </div>
    )
};
const mapStateToProps = state => {
    return{
        location:state.router.location
    }
};

export default connect(mapStateToProps,null)(PaymentRoute);